import { render, staticRenderFns } from "./InstructorDisclosures.vue?vue&type=template&id=2d96b4ef"
import script from "./InstructorDisclosures.vue?vue&type=script&lang=ts"
export * from "./InstructorDisclosures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports